import { getToken } from "@chakra-ui/react";

const baseStyle = {
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal"
  }
};

const size = {
  md: {
    fontSize: "1.4rem",
    px: 6,
    h: "36px",
    borderRadius: "24px"
  }
};

const sizes = {
  md: {
    field: size.md
  }
};

const variantOutline = (props) => {
  const { theme } = props;

  return {
    field: {
      border: "1px solid",
      borderColor: "outline",
      bg: "inherit",
      _hover: {
        borderColor: "outlineHover"
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      },
      _invalid: {
        borderColor: "warningBase",
        boxShadow: `0 0 0 1px ${getToken("colors", "warningBase")(theme)}`
      },
      _focusVisible: {
        zIndex: 1,
        borderColor: "primary",
        boxShadow: `0 0 0 1px ${getToken("colors", "primary")(theme)}`
      }
    }
  };
};

const variantUnstyled = {
  field: {
    bg: "transparent",
    px: 0,
    height: "auto",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  }
};

const variants = {
  outline: variantOutline,
  unstyled: variantUnstyled
};

const defaultProps = {
  size: "md",
  variant: "outline"
};

export default {
  baseStyle,
  sizes,
  variants,
  defaultProps
};
